import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";

export default class Totals extends BaseCom {

    render() {
        return (
            <table className="table">
                <tr>
                    <td>Sub-total</td>
                    <td>{Globals.formatPrice(this.props.session?.amount)}</td>
                </tr>
                <tr>
                    <td>Tax</td>
                    <td>{Globals.formatPrice(this.props.session?.tax)}</td>
                </tr>
                <tr>
                    <td>Total</td>
                    <td className="fw-bold">{Globals.formatPrice(this.props.session?.total)}</td>
                </tr>
            </table>
        )
    }
}